export const expertShowroomsRedirects = [
  {
    source: 'heidicaillier',
    destination: '../consultations/find-an-expert/heidicaillier/showroom',
  },
  {
    source: 'jakearnold',
    destination: '../consultations/find-an-expert/jakearnold/showroom',
  },
  {
    source: 'brigetteromanek',
    destination: '../consultations/find-an-expert/brigetteromanek/showroom',
  },
  {
    source: 'jennalyons',
    destination: '../consultations/find-an-expert/jennalyons/showroom',
  },
  {
    source: 'katierosenfeld',
    destination: '../consultations/find-an-expert/katierosenfeld/showroom',
  },
  {
    source: 'colinking',
    destination: '../consultations/find-an-expert/colinking/showroom',
  },
  {
    source: 'cameronruppert',
    destination: '../consultations/find-an-expert/cameronruppert/showroom',
  },
  {
    source: 'themisfithouse',
    destination: '../consultations/find-an-expert/themisfithouse/showroom',
  },
  {
    source: 'meghaneisenberg',
    destination: '../consultations/find-an-expert/meghaneisenberg/showroom',
  },
  {
    source: 'discinteriors',
    destination: '../consultations/find-an-expert/discinteriors/showroom',
  },
  {
    source: 'jessicahelgerson',
    destination: '../consultations/find-an-expert/jessicahelgerson/showroom',
  },
  {
    source: 'sarahshermansamuel',
    destination: '../consultations/find-an-expert/sarahshermansamuel/showroom',
  },
  {
    source: 'salvesengraham',
    destination: '../consultations/find-an-expert/salvesengraham/showroom',
  },
  {
    source: 'zoefeldman',
    destination: '../consultations/find-an-expert/zoefeldman/showroom',
  },
  {
    source: 'studiolifestyle',
    destination: '../consultations/find-an-expert/studiolifestyle/showroom',
  },
  {
    source: 'railiclasen',
    destination: '../consultations/find-an-expert/railiclasen/showroom',
  },
  {
    source: 'hadleywiggins',
    destination: '../consultations/find-an-expert/hadleywiggins/showroom',
  },
  {
    source: 'lightanddwell',
    destination: '../consultations/find-an-expert/lightanddwell/showroom',
  },
]
